import React, { useEffect, useState } from "react";
import TopHeader from "../Dashoboard/TopHeader";
import {
  useLazyFullBlockListQuery,
  useUnBlockProperyMutation,
} from "../../redux/api/api";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { saveLoader } from "../../redux/slice/loaderNoti";
import moment from "moment/moment";
import { viewIcon } from "../../assets/img";
import ReactPaginate from "react-paginate";
import { Col, Modal, Row } from "react-bootstrap";
import { GrSettingsOption } from "react-icons/gr";
import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";
import AddIcon from "@mui/icons-material/Add";
import Swal from "sweetalert2";

const FullBlock = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [details, setDetails] = useState({});
  const [page, setPage] = useState(1);
  const [list, setList] = useState([]);
  const [overAllCount, setOverALlCount] = useState(1);
  const [pagination, setPagonation] = useState({});
  const [search, setSearch] = useState("");
  const [row, setRow] = useState(10);
  const [filter, setFilter] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [modal, setModal] = useState(false);
  const [btn, setBtn] = useState(false);

  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  const [from_date, setfrom_date] = useState("");
  const [no_of_persons, setno_of_persons] = useState("");
  const [to_date, setto_date] = useState("");
  const [property_phase_service_slot_id, setproperty_phase_service_slot_id] =
    useState("");
  const [from_dateErr, setfrom_dateErr] = useState(false);
  const [no_of_personsErr, setno_of_personsErr] = useState(false);
  const [to_dateErr, setto_dateErr] = useState(false);
  const [
    property_phase_service_slot_idErr,
    setproperty_phase_service_slot_idErr,
  ] = useState(false);
  const [no_of_rooms, setno_of_rooms] = useState("");
  const [no_of_roomsErr, setno_of_roomsErr] = useState(false);
  const [unblockObj, setUnblockObj] = useState({});

  // RTK QUERY
  const [fullBlockListApi] = useLazyFullBlockListQuery();
  const [unBlockProperyApi] = useUnBlockProperyMutation();

  const getDetails = (
    search_value,
    row_value,
    filter_value,
    from_date,
    to_date
  ) => {
    let params = `?page=${page}`;

    if (search_value) {
      params += `&search=${search_value}`;
    }

    if (row_value) {
      params += `&row=${row_value}`;
    }

    if (filter_value) {
      params += `&filter=${filter_value}`;
    }

    if (from_date) {
      params += `&from_date=${moment(from_date).format("YYYY-MM-DD")}`;
    }

    if (to_date) {
      params += `&to_date=${moment(to_date).format("YYYY-MM-DD")}`;
    }
    setRow(row_value);
    setFilter(filter_value);
    setToDate(to_date);
    setFromDate(from_date);
    setSearch(search_value);
    dispatch(saveLoader(true));

    fullBlockListApi(params)
      .unwrap()
      .then((res) => {
        dispatch(saveLoader(false));
        setList(res?.blocked_properties);
        setDetails(res);
        setOverALlCount(
          Math.ceil(res?.pagination?.total / res?.pagination?.per_page)
        );
        setPagonation(res?.pagination);
      })
      .catch((err) => {
        dispatch(saveLoader(false));
        console.log(err, "err");
      });
  };

  const minMaxDate = () => {
    var someDate = new Date();

    // min date
    someDate.setDate(someDate.getDate()); //number  of days to add, e.x. 15 days
    var dateFormated = someDate.toISOString().substr(0, 10);
    setMinDate(dateFormated);

    // max date
    someDate.setDate(someDate.getDate() + 7); //number  of days to add, e.x. 15 days
    var dateFormateds = someDate.toISOString().substr(0, 10);
    setMaxDate(dateFormateds);
  };

  useEffect(() => {
    getDetails(search, row);
  }, [page]);

  useEffect(() => {
    minMaxDate();
  }, []);

  const handlePageChange = (selectedObject) => {
    setPage(selectedObject.selected + 1);
  };

  const onOpen = (item) => {
    setUnblockObj(item);
    setModal(true);
  };

  const onClose = () => {
    setUnblockObj({});
    setfrom_date("");
    setto_date("");
    setno_of_persons("");
    setproperty_phase_service_slot_id("");
    setfrom_dateErr(false);
    setto_dateErr(false);
    setno_of_personsErr(false);
    setproperty_phase_service_slot_idErr(false);
    setno_of_rooms("");
    setno_of_roomsErr(false);
    setModal(false);
  };

  const phaseBlock = () => {
    if (from_date?.length == 0 || to_date?.length == 0) {
      setfrom_dateErr(true);
      setto_dateErr(true);
    } else {
      const formdata = new FormData();

      formdata.append("from_date", moment(from_date).format("YYYY-MM-DD"));
      formdata.append("to_date", moment(to_date).format("YYYY-MM-DD"));
      formdata.append("id", unblockObj?.id);

      dispatch(saveLoader(true));
      setBtn(true);
      unBlockProperyApi(formdata)
        .unwrap()
        .then((res) => {
          Swal.fire({
            text: res?.message,
            icon: "success",
          });
          dispatch(saveLoader(false));
          setBtn(false);
          onClose();
        })
        .catch((err) => {
          console.log("err", err);
          dispatch(saveLoader(false));
          setBtn(false);
        });
    }
  };

  return (
    <div className="dashRightView home_section">
      <TopHeader type={"full-block"} />
      <div className="block block-rounded ">
        <div className="block-content">
          <Row>
            <Col md={6}>
              <label className="table-labels f1">
                Total Count : {pagination?.total}
              </label>
            </Col>
          </Row>
          <div className="d-flex ac-jb gap-2">
            <div className="col-md-2 mb-2 p-0">
              <select
                className="form-control custom-select"
                onChange={(e) =>
                  getDetails(search, e.target.value, filter, fromDate, toDate)
                }
                value={row}
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </div>
            <div className="col-md-2 mb-2 p-0">
              <DatePicker
                selected={fromDate}
                onChange={(date) => {
                  getDetails(search, row, filter, date, toDate);
                }}
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-2 mb-2 p-0">
              <DatePicker
                selected={toDate}
                onChange={(date) =>
                  getDetails(search, row, filter, fromDate, date)
                }
                peekNextMonth
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                dateFormat="yyyy-MM-dd"
                todayButton="Today"
                className="form-control custom-select"
                placeholderText="YYYY-MM-DD"
              />
            </div>
            <div className="col-md-3 mb-2 p-0">
              <input
                className="form-control bg-white"
                placeholder="Eg : Property Id"
                onChange={(e) =>
                  getDetails(e.target.value, row, filter, fromDate, toDate)
                }
                value={search}
              />
            </div>
          </div>
          <div className="table-custom-design overflow-scroll">
            <table>
              <thead>
                <tr className="text-capitalize text-nowrap">
                  <th>S.NO</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>Blocked By</th>
                  <th>Blocked Person</th>
                  <th>Raised Date</th>
                  <th>Owner Id</th>
                  <th>Property ID</th>
                  <th>Unblock</th>
                </tr>
              </thead>
              <tbody>
                {list?.map((item, ind) => {
                  return (
                    <tr key={ind}>
                      <td>{(pagination?.current_page - 1) * row + ind + 1}</td>
                      <td>
                        {item?.from_date
                          ? moment(item?.from_date).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {item?.to_date
                          ? moment(item?.to_date).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td>
                        {item?.blocked_type == 1
                          ? "Owner"
                          : item?.booked_by == 2
                          ? "Receptionist"
                          : "Admin"}
                      </td>
                      <td>
                        {item?.blocked_type == 1 ? (
                          <button
                            className="link-btn"
                            onClick={() => {
                              navigate("/property-owner-view", {
                                state: { data: item?.owner, type: "view" },
                              });
                            }}
                          >
                            {item?.owner?.name ? item?.owner?.name : "-"}
                          </button>
                        ) : item?.booked_by == 2 ? (
                          <button className="link-btn">
                            {item?.receptionist?.name
                              ? item?.receptionist?.name
                              : "-"}
                          </button>
                        ) : (
                          <button
                            className="link-btn"
                            onClick={() =>
                              navigate("/admin", {
                                state: { type: "view", data: item?.admin },
                              })
                            }
                          >
                            {item?.admin?.name ? item?.admin?.name : "-"}
                          </button>
                        )}
                      </td>
                      <td>
                        {item?.created_at
                          ? moment(item?.created_at).format("DD-MM-YYYY")
                          : "-"}
                      </td>
                      <td className="text-nowrap">
                        <button
                          className="link-btn"
                          onClick={() =>
                            navigate("/property-owner-view", {
                              state: { data: item?.owner, type: "view" },
                            })
                          }
                        >
                          {item?.property?.owner?.owner_id
                            ? item?.property?.owner?.owner_id
                            : "-"}
                        </button>
                      </td>
                      <td>
                        <button
                          className="link-btn"
                          onClick={() => {
                            navigate("/property-view", {
                              state: { type: "edit", data: item?.property },
                            });
                          }}
                        >
                          {item?.property?.property_id
                            ? item?.property?.property_id
                            : "-"}
                        </button>
                      </td>
                      <td>
                        <button
                          className="badge-secondry"
                          onClick={() => onOpen(item)}
                        >
                          <GrSettingsOption className="" />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="page-inner-cont py-2 d-flex justify-content-end">
            <ReactPaginate
              nextLabel="››"
              onPageChange={handlePageChange}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={overAllCount}
              previousLabel="‹‹"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>

      <Modal
        show={modal}
        onHide={() => {
          setModal(false);
        }}
        aria-labelledby="contained-modal-title-vcenter"
      >
        <div className="p-3">
          <Row>
            <div className="d-flex ac-jb">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18">
                Unblock Room
              </label>
              <button className="cust-btn" onClick={() => onClose(false)}>
                <CloseIcon />
              </button>
            </div>
          </Row>
          <Row>
            <div className="d-flex ac-jb mt-4">
              <div className="mx-2">
                <p className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                  From Date
                </p>
                <p className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                  {unblockObj?.from_date
                    ? moment(unblockObj?.from_date).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </div>
              <div className="mx-2">
                <p className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                  To Date
                </p>
                <p className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                  {unblockObj?.from_date
                    ? moment(unblockObj?.to_date).format("DD-MM-YYYY")
                    : "-"}
                </p>
              </div>
            </div>
          </Row>
          <Row className="mt-2">
            <div className="col-md-12 mb-4">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                From Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={from_date}
                  onChange={(date) => {
                    setfrom_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={minDate}
                  maxDate={maxDate}
                />
              </div>
              {from_date?.length == 0 && from_dateErr && (
                <p className="err">Select From Date</p>
              )}
            </div>
            <div className="col-md-12 mb-4">
              <label className="f2 fs-sm-12 fs-md-12 fs-lg-14 fs-xl-16 fs-xxl-18 mb-2 col-md-12">
                To Date
              </label>
              <div className="full-date-pick">
                <DatePicker
                  selected={to_date}
                  onChange={(date) => {
                    setto_date(date);
                  }}
                  peekNextMonth
                  showMonthDropdown
                  showYearDropdown
                  dropdownMode="select"
                  dateFormat="yyyy-MM-dd"
                  todayButton="Today"
                  className="form-control custom-select"
                  placeholderText="YYYY-MM-DD"
                  minDate={minDate}
                  //   maxDate={maxDate}
                />
              </div>
              {to_date?.length == 0 && to_dateErr && (
                <p className="err">Select To Date</p>
              )}
            </div>
          </Row>
          <Row className="mt-4 d-flex ac-jc">
            <div className="col-md-2 text-center">
              <button
                className={`submit-btn ${btn ? "opacity-50" : ""}`}
                onClick={() => phaseBlock()}
                disabled={btn}
              >
                OK
              </button>
            </div>
          </Row>
        </div>
      </Modal>
    </div>
  );
};

export default FullBlock;
